import React from 'react';
import { Field } from 'react-final-form';

import Checkbox from '../../../../../Checkbox/Checkbox';

import { TXTWCL_Email_me_about_special_offers__ELL } from './MarketingMailList.messages.json';

const fieldName = 'marketingMailList';

const MarketingMailList: React.FunctionComponent = () => (
  <Field name={fieldName} type="checkbox">
    {({ input: { onChange, checked } }) => (
      <Checkbox
        checked={checked}
        name={fieldName}
        onChange={onChange}
        label={TXTWCL_Email_me_about_special_offers__ELL}
      />
    )}
  </Field>
);

export default MarketingMailList;
